import React, { useState } from 'react';
import classNames from 'classnames';

import styles from './Dropdown.module.css';

import ThemedIcon from '@components/ThemedIcon';

type Option = {
  label: string;
  shortCode: string;
};

type Props = {
  options?: Option[];
  value?: Option;
  onSelect?: (option: Option) => void;
  className?: string;
  menuClassName?: string;
  type?: 'info' | 'default';
  infoComponent?: React.ReactElement;
  toTop?: boolean;
};

export function Dropdown({
  options,
  onSelect,
  value,
  className,
  type = 'default',
  infoComponent,
  toTop,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelectOption = (option: Option) => {
    setIsOpen(false);
    onSelect?.(option);
  };

  return (
    <div className={className}>
      <div className={styles.dropdown}>
        <div
          className={classNames(styles.dropdown_toggle)}
          onClick={handleToggleDropdown}
        >
          <ThemedIcon name='locale' width={12} height={12} />
          <div
            className={classNames(
              styles.dropdown_toggle__label,
              'text-text-primary'
            )}
          >
            {value?.label}
          </div>
        </div>

        {isOpen && type === 'default' && (
          <div
            className={classNames(styles.dropdown_menu, {
              [styles.toTop]: toTop,
            })}
          >
            {options &&
              options.length > 0 &&
              options.map((option) => (
                <div
                  className={styles.dropdown_menu__item}
                  key={option.label}
                  onClick={() => handleSelectOption(option)}
                >
                  {option.label}
                  {value?.shortCode === option.shortCode && (
                    <ThemedIcon
                      name='check'
                      width={16}
                      height={16}
                      className='ml-auto'
                    />
                  )}
                </div>
              ))}
          </div>
        )}
      </div>
      {isOpen && type === 'info' && (
        <div className={classNames(styles.dropdown_menu, styles.menuClassName)}>
          {infoComponent}
        </div>
      )}
    </div>
  );
}
